import { createFileRoute } from '@tanstack/react-router'

import { CertificateInfoPage } from '../../../../components/pages/certificate/certificate-info-page.tsx'
import { certificateSearchSchema } from '../certificate-search-schema.ts'

export const Route = createFileRoute('/s/a/$token/')({
  validateSearch: certificateSearchSchema,
  component: function RouteComponent() {
    const { token } = Route.useParams()
    const { lg } = Route.useSearch()

    return <CertificateInfoPage token={token} language={lg} />
  },
})
